import { useEffect, useState } from 'react';
import { Alert } from '@mui/material';
import { IMPERSONATION_MARKER_KEY, impersonationsInOtherTabs, type ImpersonationMarker } from './sessionToken';

/** Treść ostrzeżenia — kogo przejęto w innej karcie. */
export function otherTabImpersonationText(markers: readonly ImpersonationMarker[]): string {
  const who = markers.map((m) => m.target).join(', ');
  return `W innej karcie trwa praca jako ${who} — ta karta działa na Twoim koncie.`;
}

/**
 * Ostrzeżenie w karcie, która NIE pracuje jako inny użytkownik, gdy w tej
 * przeglądarce trwa przejęcie w innej karcie (przegląd bezpieczeństwa #582,
 * D5). Karta otwarta odnośnikiem z karty przejęcia nie dostaje jej sesji
 * (`sessionStorage` jest per karta) i pracuje na koncie z logowania — bez
 * ostrzeżenia łatwo pomylić, na czyim koncie się zapisuje. Odświeża się, gdy
 * inna karta zacznie albo zakończy przejęcie (zdarzenie `storage`), i co
 * minutę (koniec ważności sesji).
 */
export const OtherTabImpersonationNotice = () => {
  const [markers, setMarkers] = useState<ImpersonationMarker[]>(() => impersonationsInOtherTabs());
  useEffect(() => {
    const refresh = () => setMarkers(impersonationsInOtherTabs());
    const onStorage = (e: StorageEvent) => {
      if (e.key === null || e.key === IMPERSONATION_MARKER_KEY) refresh();
    };
    window.addEventListener('storage', onStorage);
    const timer = window.setInterval(refresh, 60_000);
    return () => {
      window.removeEventListener('storage', onStorage);
      window.clearInterval(timer);
    };
  }, []);
  if (markers.length === 0) return null;
  return (
    <Alert severity="warning" sx={{ mb: 1 }} data-testid="impersonation-other-tab">
      {otherTabImpersonationText(markers)}
    </Alert>
  );
};

export default OtherTabImpersonationNotice;
